import React from 'react';
import { Mail, Lock, Eye, User, Phone } from 'lucide-react';

export default function LoginFormPreview({ attributes = {}, formType = 'login' }) {
  const brandName = attributes.brandName || attributes.brand?.name || 'Brand';
  const isLogin = formType === 'login' || attributes.formType === 'login';

  return (
    <div style={{
      maxWidth: '400px', margin: '0 auto', padding: '40px 32px',
      fontFamily: 'Inter, system-ui, sans-serif',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', marginBottom: '4px' }}>
          {brandName}
        </h2>
        <p style={{ fontSize: '14px', color: '#6b7280' }}>
          {isLogin ? 'Welcome back' : 'Create your account'}
        </p>
      </div>

      {/* Google OAuth */}
      <button style={{
        width: '100%', padding: '10px', borderRadius: '8px',
        border: '1px solid #e5e7eb', background: '#fff', cursor: 'default',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
        fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '20px',
      }}>
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Continue with Google
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
        <span style={{ fontSize: '12px', color: '#9ca3af' }}>OR</span>
        <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
      </div>

      {/* Form fields */}
      {!isLogin && (
        <FormField icon={User} label="Full Name" placeholder="John Doe" showEye={false} />
      )}
      <FormField icon={Mail} label="Email" placeholder="you@example.com" showEye={false} />
      {!isLogin && (
        <FormField icon={Phone} label="Phone" placeholder="+91 98765 43210" showEye={false} />
      )}
      <FormField icon={Lock} label="Password" placeholder="Enter your password" showEye />
      {!isLogin && (
        <>
          <FormField icon={Lock} label="Confirm Password" placeholder="Confirm password" showEye />
          {/* Password strength */}
          <div style={{ display: 'flex', gap: '4px', marginBottom: '16px' }}>
            {[1, 2, 3, 4].map(i => (
              <div key={i} style={{
                flex: 1, height: '3px', borderRadius: '2px',
                background: i <= 3 ? '#22c55e' : '#e5e7eb',
              }} />
            ))}
          </div>
        </>
      )}

      {isLogin && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '20px',
        }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#6b7280', cursor: 'default' }}>
            <input type="checkbox" checked readOnly style={{ accentColor: '#4f46e5' }} /> Remember me
          </label>
          <span style={{ fontSize: '12px', color: '#4f46e5', fontWeight: 500 }}>Forgot password?</span>
        </div>
      )}

      <button style={{
        width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
        background: '#111827', color: '#fff', fontSize: '14px', fontWeight: 600,
        cursor: 'default',
      }}>
        {isLogin ? 'Sign In' : 'Create Account'}
      </button>

      <p style={{ textAlign: 'center', fontSize: '13px', color: '#6b7280', marginTop: '16px' }}>
        {isLogin ? "Don't have an account? " : "Already have an account? "}
        <span style={{ color: '#4f46e5', fontWeight: 500 }}>
          {isLogin ? 'Sign up' : 'Sign in'}
        </span>
      </p>
    </div>
  );
}

function FormField({ icon: Icon, label, placeholder, showEye }) {
  return (
    <div style={{ marginBottom: '16px' }}>
      <label style={{ fontSize: '12px', fontWeight: 500, color: '#374151', display: 'block', marginBottom: '6px' }}>
        {label}
      </label>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '10px 12px', borderRadius: '8px', border: '1px solid #e5e7eb',
        background: '#fff',
      }}>
        <Icon size={16} style={{ color: '#9ca3af', flexShrink: 0 }} />
        <span style={{ flex: 1, fontSize: '13px', color: '#9ca3af' }}>{placeholder}</span>
        {showEye && <Eye size={16} style={{ color: '#9ca3af', flexShrink: 0 }} />}
      </div>
    </div>
  );
}
